import React from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import Form from 'components/Form';
import Button from 'components/Button';
import TextInput from 'components/TextInput';
import ListHeader from 'components/ListHeader';
import MainContainer from 'components/MainContainer';
import LoadingOverlay from 'components/LoadingOverlay';
import { getUser, updateUser } from 'api/users';
import SelectInput from 'components/SelectInput';

const presence = {
    allowEmpty: false,
    message: "^campo obbligatorio"
}

const constraints = {
    name: { presence },
    email: { presence },
    confirmPassword: {
        equality: {
            attribute: "password",
            message: "^le password non coincidono"
        }
    }
}

export default function ModificaUtente() {

    const { userId } = useParams();

    let { data, isPending } = useQuery({
        queryKey: ["utente", userId],
        queryFn: async () => {
            let data = await getUser({ userId: userId });
            return {
                ...data,
                email: data?.emails?.[0]?.address
            }
        },
        enabled: !!userId
    });

    const navigate = useNavigate();

    const { mutate, status } = useMutation({
        mutationFn: updateUser,
        onSuccess: () => {
            return navigate(`/impostazioni/utenti/${userId}`)
        },
        onError: (error) => {
            console.error(error);
        }
    })

    function onSubmitHandler(data) {

        let payload = {
            name: data.name,
            superuser: data.superuser,
            email: data.email
        };

        if (data.password) {
            payload.password = data.password;
        }

        return mutate({
            userId: userId,
            data: payload
        });
    }

    const formData = {
        name: data?.name,
        email: data?.emails?.[0]?.address,
        password: data?.password,
        superuser: data?.superuser || false
    }

    return (
        <>

            <LoadingOverlay visible={isPending} />

            <MainContainer>
                <div className='pt-10 pb-5'>
                    <ListHeader
                        backLink={`/impostazioni/utenti/${userId}`}
                        title="Modifica utente"
                    />
                </div>

                <div className='bg-white p-8 rounded-[40px]'>
                    <Form onSubmit={onSubmitHandler} constraints={constraints} data={formData}>

                        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4 w-full'>
                            <TextInput
                                name="name"
                                label="Nome"
                                placeholder="Inserisci il nome"
                            />
                            <TextInput
                                name="email"
                                label="Email"
                                placeholder="Inserisci l'email"
                                required
                            />
                            <TextInput
                                type="password"
                                name="password"
                                label="Password"
                                placeholder="Inserisci la password"
                            />
                            <SelectInput
                                name="superuser"
                                label="Superuser"
                                options={[
                                    { value: true, label: "Sì" },
                                    { value: false, label: "No" }
                                ]}
                                defaultValue={{ value: false, label: "No" }}
                            />
                        </div>

                        <div className='flex'>
                            <Button submit status={status}>Conferma</Button>
                        </div>
                    </Form>
                </div>
            </MainContainer>
        </>
    )
}
